import { render } from "./VitAccordion.vue?vue&type=template&id=be4a5eea&ts=true"
import script from "./VitAccordion.vue?vue&type=script&lang=ts"
export * from "./VitAccordion.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__